// extracted by mini-css-extract-plugin
export default {"lessonCard":"LessonCard_lessonCard__Bdz9u","outer":"LessonCard_outer__QUhaM","inner":"LessonCard_inner__g7MLb","buyButton":"LessonCard_buyButton__xiBlU"};